export default "__VITE_ASSET__C5ffO$jk__"